import {
    unknownCapacity,
    capacitySingle,
    capacity,
    noAddress,
    noPhoneNumber,
    reservedRoom,
} from '../strings.locstring.json';
import loc, { format } from 'owa-localize';
import getStore from 'owa-location-card-v2/lib/data/store';

import { getLocalizedAddressFromDetails } from 'owa-location-persona';
import { isNullOrWhiteSpace } from 'owa-string-utils';

/**
 * Returns true if the capacity property is set
 */
export function isCapacitySet(): boolean {
    const place = getStore().place;
    return (
        place &&
        place.ResourceDetails &&
        place.ResourceDetails.Capacity !== undefined &&
        place.ResourceDetails.Capacity != null
    );
}

/**
 * Returns the place holder for the room capacity text
 */
export function getCapacityPlaceholder(): string {
    const place = getStore().place;

    return place && place.Type == 'Room' && !isCapacitySet() ? loc(unknownCapacity) : '';
}

/**
 * Gets the Capacity string. It is either 1 person, x people
 */
export function getCapacityString(): string {
    const place = getStore().place;
    if (!place || place.Type != 'Room' || !isCapacitySet()) {
        return '';
    }

    return place.ResourceDetails.Capacity == 1
        ? loc(capacitySingle)
        : format(loc(capacity), place.ResourceDetails.Capacity);
}

/**
 * Gets the formatted address of the location
 */
export function getFormatterAddress(): string {
    const place = getStore().place;

    return place.Address
        ? getLocalizedAddressFromDetails(
              place.Address.Street,
              place.Address.City,
              place.Address.PostalCode,
              place.Address.State,
              place.Address.CountryOrRegion
          )
        : '';
}

/**
 * Gets the place holder for the place address
 */
export function getAddressPlaceholder(): string {
    return getFormatterAddress() ? '' : loc(noAddress);
}

/** Gets whether the place has Lat Long */
export function hasCoordinates(): boolean {
    const place = getStore().place;
    return !!(place.Coordinates && place.Coordinates.Latitude && place.Coordinates.Longitude);
}

/**
 * Returns true if the place has a phone number
 */
export function hasPhoneNumber() {
    return !isNullOrWhiteSpace(getStore().place.PhoneNumber);
}

/**
 * Gets the phone place holder text for non public places that don't have a phone number
 */
export function getPhonePlaceholder(): string {
    const place = getStore().place;
    if (!place || hasPhoneNumber() || place.Type == 'PublicPlace') {
        return '';
    }

    return loc(noPhoneNumber);
}

/**
 *  Gets the reserved room booking type text.
 *  If the place is a reserved room then we return 'reserved room'. We don't show any text otherwise.
 */
export function getReservedRoomString(): string {
    const place = getStore().place;

    return place.ResourceDetails && place.ResourceDetails.BookingType == 'Reserved'
        ? loc(reservedRoom)
        : '';
}

/**
 * Returns the building of the room if it is defined .
 */
export function getBuildingString(): string {
    const place = getStore().place;
    return place.ResourceDetails && !isNullOrWhiteSpace(place.ResourceDetails.Building)
        ? place.ResourceDetails.Building
        : '';
}

/**
 * returns the website if present or empty string
 */
export function getWebsiteString(): string {
    const place = getStore().place;
    return (place.PlaceDetails && place.PlaceDetails.BusinessUrl) || '';
}

/**
 * returns the label text for unknown places or non enhanced personal places
 */
export function getLabelString(): string {
    const place = getStore().place;
    return ((place.Type == 'Unknown' || place.Type == 'PersonalPlace') && place.Name) || '';
}

export function isLocationInCache(locationId: string): boolean {
    const place = getStore().place;
    return place.Id && locationId.toLowerCase() == place.Id.toLowerCase();
}

/**
 * Returns the whether working hours are set or not
 */
export function isWorkingHourSet(): boolean {
    let place = getStore().place;
    return (
        place &&
        place.PlaceDetails &&
        place.PlaceDetails.OpeningHoursSpecifications &&
        place.PlaceDetails.OpeningHoursSpecifications.length > 0
    );
}
